import React from "react";
import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import Stack from "@mui/material/Stack";
import ClearStoreData from "./components/ClearStoreData";

const RelatedAgenciesButton = (props) => {
  const { inputId } = props;
  const dispatch = useDispatch();
  const handleClick = () => {
    const parentAgency = sessionStorage.getItem("agencyId")
    ClearStoreData({ inputId, dispatch, value: parentAgency });
  };

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <IconButton
        variant="outlined"
        onClick={handleClick}
        disabled={inputId === ""}
        color="secondary"
      >
        <SendIcon />
      </IconButton>
    </Stack>
  );
};

export default RelatedAgenciesButton;
